const SHOW_PROJECT = 'PROJECT_SHOW';
const HIDE_PROJECT = 'PROJECT_HIDE';

export const showProject = () => ({
  type: SHOW_PROJECT,
});

export const hideProject = () => ({
  type: HIDE_PROJECT,
});

const defaultState = {
  projectIsVisible: false,
};

export default function (state = defaultState, action) {

  switch (action.type) {
    case SHOW_PROJECT: {
      const stateClone = Object.assign({}, state);
      stateClone.projectIsVisible = true;

      return stateClone;
    }

    case HIDE_PROJECT: {
      const stateClone = Object.assign({}, state);
      stateClone.projectIsVisible = false;

      return stateClone;
    }

    default : {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/PortfolioReducer.js